<template>
  <zg-module
    v-bind="moduleProps"
    class="zg-logo-card-section"
  >
    <slot
      slot="sub-title"
      name="sub-title"
    />

    <slot />

    <zg-logo-cards
      v-if="items && items.length"
      :items="items"
      :background="cardBackground"
    />
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgLogoCards from '../../ZgLogoCards/ZgLogoCards.vue'
  import ZgModule from '../ZgModule/ZgModule.vue'

  export default {
    name: 'ZgLogoCardSection',
    components: {
      ZgLogoCards,
      ZgModule
    },
    mixins: [module],
    props: {
      items: {
        type: Array,
        required: true,
        validator: items => items?.length > 0
      }
    }
  }
</script>
